import { FC, ReactNode } from "react"
import { useSelector } from "react-redux"
import {
  selectWBTokenBlocking,
  selectWBTokenInfo,
  selectWBTokenLoaded,
  selectWBTokenNonBlocking,
} from "../../app/reducers/wbTokenSlice"
import s from "./WBTokenGuard.module.css"
import { useNavigate } from "react-router-dom"

type Props = {
  children: ReactNode
}

export const WBTokenGuard: FC<Props> = ({ children }) => {
  const blocking = useSelector(selectWBTokenBlocking)
  const nonBlocking = useSelector(selectWBTokenNonBlocking)
  const loaded = useSelector(selectWBTokenLoaded)
  const tokenInfo = useSelector(selectWBTokenInfo)
  const navigate = useNavigate()

  if (!loaded) return null

  // Базовый токен не умеет в Аналитику/Финансы — подсвечиваем это явно,
  // чтобы пользователь понимал причину блокировки и знал, что делать.
  const isBaseToken = tokenInfo?.isBaseToken === true

  if (blocking.length > 0) {
    return (
      <div className={s.container}>
        <div className={s.card}>
          <p className={s.subtitle}>
            {isBaseToken
              ? "⚠️ Установлен базовый токен WB. Аналитика и Финансы недоступны."
              : "Токен не установлен или не имеет необходимых разрешений."}
          </p>

          <div className={s.warningsList}>
            {blocking.map((w, i) => (
              <div key={i} className={s.warningItem}>
                <span className={s.warningDot} />
                {w}
              </div>
            ))}
          </div>

          <p
            className={s.hint}
            onClick={() => navigate("/settings/tokenManager")}
          >
            {isBaseToken
              ? "Замените токен на персональный в ЛК WB → Профиль → Доступ к API, затем обновите его в разделе «Настройки»"
              : "Перейдите в раздел «Настройки» и обновите токен WB"}
          </p>
        </div>
      </div>
    )
  }

  return (
    <>
      {children}
      {nonBlocking.length > 0 && (
        <div
          className={s.indicator}
          onClick={() => navigate("/settings/tokenManager")}
          role="button"
          tabIndex={0}
        >
          <span className={s.indicatorIcon} aria-hidden>
            !
          </span>
          <div className={s.indicatorTooltip}>
            <p className={s.tooltipTitle}>
              Часть функций может быть недоступна:
            </p>
            <ul className={s.tooltipList}>
              {nonBlocking.map((w, i) => (
                <li key={i}>{w}</li>
              ))}
            </ul>
            <p className={s.tooltipHint}>Нажмите, чтобы обновить токен WB</p>
          </div>
        </div>
      )}
    </>
  )
}
